<template>
    <div class="form-content form-container home-step" :ref="stepName" style="position:relative">
        <div class="form-header">
            <p><span>Ik verklaar dat ik het <a @click.prevent="openModal('infos','privacy')">privacybeleid</a> heb gelezen en geaccepteerd
            dat gebruikt zal worden voor de administratieve en commerciële opvolging van mijn aanvraag, gelezen en aanvaard.</span></p>
        </div>
        <OptinForm></OptinForm>
        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import {Button} from "../../../../../../models/fields/Button";
import OptinForm from "./OptinForm.vue";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";
import modal_mixin from "../../../../../../views/_commons/nl/mixins/modal_mixin";

export default {
    components: {OptinForm},
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin,modal_mixin],
}
</script>
